import { useEffect, useState } from 'react'
import { useUrlFilters } from 'src/libs/useUrlFilters'
import { FILTER_CONFIG_COMMISSION } from 'src/pages/finSystem/balanceSummary/reports/const'
import { commissionListLoad } from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/model'
import { getPeriodByRange } from 'src/pages/finSystem/balanceSummary/reports/utils'
import {
  CommissionListFilter,
  CommissionListTable,
} from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/components'
import {
  FormCommissionValue,
  SortObject,
} from 'src/pages/finSystem/balanceSummary/reports/reportCommissions/types'
import dayjs from 'dayjs'

export const CommissionListSection = () => {
  const {
    filters,
    setFilters,
    resetFilters: reset,
  } = useUrlFilters(FILTER_CONFIG_COMMISSION)

  const { dateFrom, dateTo, walletIds, currencies, type, sorterField } = filters

  const [sorter, setSorter] = useState<SortObject>(() => {
    if (!sorterField) return undefined

    return {
      direction: sorterField?.startsWith('-') ? 'descend' : 'ascend',
      field: sorterField?.startsWith('-') ? sorterField.slice(1) : sorterField,
    }
  })

  const getInitialValueForm = () => {
    const result: FormCommissionValue = {}
    const period = getPeriodByRange(dateFrom, dateTo)

    result['periodDatePicker'] =
      period === 'date_range' ? [dayjs(dateFrom), dayjs(dateTo)] : undefined

    result['period'] = period
    result['walletIds'] = walletIds
    result['currencies'] = currencies
    result['type'] = type

    return result
  }

  const resetFilters = () => {
    reset()
    setSorter(undefined)
  }

  useEffect(() => {
    commissionListLoad({
      dateFrom,
      dateTo,
      walletIds: walletIds ?? [],
      currencies: currencies ?? [],
      type,
      sorterField,
    })
  }, [dateFrom, dateTo, walletIds, currencies, type, sorterField])

  return (
    <>
      <CommissionListFilter
        filters={filters}
        setFilters={setFilters}
        resetFilters={resetFilters}
        initialValueForm={getInitialValueForm()}
      />
      <br />
      <CommissionListTable
        sort={sorter}
        setSort={setSorter}
        setFilters={setFilters}
      />
    </>
  )
}
